import { render, staticRenderFns } from "./model_7.vue?vue&type=template&id=71280d5e&scoped=true"
import script from "./model_7.vue?vue&type=script&lang=js"
export * from "./model_7.vue?vue&type=script&lang=js"
import style0 from "./model_7.vue?vue&type=style&index=0&id=71280d5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71280d5e",
  null
  
)

export default component.exports